import type { Ref } from 'react';
import { useEffect, useMemo, useState } from 'react';

/**
 * A Hook using the Intersection Observer API to determine if
 * a component is in the document viewport or not.
 */
export const useIsOnScreen = (ref: Ref<HTMLElement>): boolean => {
    const [isIntersecting, setIntersecting] = useState(false);

    const observer = useMemo(
        () => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)),
        [],
    );

    useEffect(() => {
        const isRefObject = !!ref && 'current' in ref;
        if (isRefObject) {
            // need the non-null assertion to satisfy strict null checks
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            observer.observe(ref.current!);
        }
        return () => observer.disconnect();
    }, [ref, observer]);

    return isIntersecting;
};
